import {Component, Input, TemplateRef} from '@angular/core';

@Component({
    selector: '[step-page-body]',
    exportAs: 'stepPageBody',
    templateUrl: './step-page-body.component.html',
})
export class StepPageBodyComponent {
    @Input() content: TemplateRef<void>;

}
